import React, { useState } from 'react'
import Lottie from 'react-lottie-player'
import talkingHeadAnimation from '../../assets/talking_head.json'
import axios from 'axios'

const TalkingHead = ({ text, containerStyles = styles.container }) => {
  const [isSpeaking, setIsSpeaking] = useState(false)

  const url = 'https://api.d-id.com/talks'

  const urlTalk = 'https://api.d-id.com/talks/tlk_5spAiNx3NEgme8jwqeWrU';
  const optionsGetTalk = {
    method: 'GET',
    headers: {
      accept: 'application/json',
      authorization: 'Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6Ik53ek53TmV1R3ptcFZTQjNVZ0J4ZyJ9.eyJodHRwczovL2QtaWQuY29tL2ZlYXR1cmVzIjoiIiwiaHR0cHM6Ly9kLWlkLmNvbS9zdHJpcGVfcHJvZHVjdF9pZCI6IiIsImh0dHBzOi8vZC1pZC5jb20vc3RyaXBlX2N1c3RvbWVyX2lkIjoiIiwiaHR0cHM6Ly9kLWlkLmNvbS9zdHJpcGVfcHJvZHVjdF9uYW1lIjoidHJpYWwiLCJodHRwczovL2QtaWQuY29tL3N0cmlwZV9zdWJzY3JpcHRpb25faWQiOiIiLCJodHRwczovL2QtaWQuY29tL3N0cmlwZV9iaWxsaW5nX2ludGVydmFsIjoibW9udGgiLCJodHRwczovL2QtaWQuY29tL3N0cmlwZV9wbGFuX2dyb3VwIjoiZGVpZC10cmlhbCIsImh0dHBzOi8vZC1pZC5jb20vc3RyaXBlX3ByaWNlX2lkIjoiIiwiaHR0cHM6Ly9kLWlkLmNvbS9zdHJpcGVfcHJpY2VfY3JlZGl0cyI6IiIsImh0dHBzOi8vZC1pZC5jb20vY2hhdF9zdHJpcGVfc3Vic2NyaXB0aW9uX2lkIjoiIiwiaHR0cHM6Ly9kLWlkLmNvbS9jaGF0X3N0cmlwZV9wcmljZV9jcmVkaXRzIjoiIiwiaHR0cHM6Ly9kLWlkLmNvbS9jaGF0X3N0cmlwZV9wcmljZV9pZCI6IiIsImh0dHBzOi8vZC1pZC5jb20vcHJvdmlkZXIiOiJnb29nbGUtb2F1dGgyIiwiaHR0cHM6Ly9kLWlkLmNvbS9pc19uZXciOmZhbHNlLCJodHRwczovL2QtaWQuY29tL2FwaV9rZXlfbW9kaWZpZWRfYXQiOiIyMDI1LTAxLTAyVDE1OjExOjQwLjIzMloiLCJodHRwczovL2QtaWQuY29tL29yZ19pZCI6IiIsImh0dHBzOi8vZC1pZC5jb20vYXBwc192aXNpdGVkIjpbIlN0dWRpbyJdLCJodHRwczovL2QtaWQuY29tL2N4X2xvZ2ljX2lkIjoiIiwiaHR0cHM6Ly9kLWlkLmNvbS9jcmVhdGlvbl90aW1lc3RhbXAiOiIyMDI1LTAxLTAyVDE1OjEwOjM4Ljg2NloiLCJodHRwczovL2QtaWQuY29tL2FwaV9nYXRld2F5X2tleV9pZCI6InNwc2x6N2ZzcjkiLCJodHRwczovL2QtaWQuY29tL3VzYWdlX2lkZW50aWZpZXJfa2V5IjoickZyTk5SbGtyV25MM3VSNFpyZnA1IiwiaHR0cHM6Ly9kLWlkLmNvbS9oYXNoX2tleSI6ImZMNVZJRUNGVHB0Z0c2YUpCM3ROaCIsImh0dHBzOi8vZC1pZC5jb20vcHJpbWFyeSI6dHJ1ZSwiaHR0cHM6Ly9kLWlkLmNvbS9lbWFpbCI6ImZhdGVoLmFsbGFtQGdtYWlsLmNvbSIsImh0dHBzOi8vZC1pZC5jb20vY291bnRyeV9jb2RlIjoiUEsiLCJodHRwczovL2QtaWQuY29tL3BheW1lbnRfcHJvdmlkZXIiOiJzdHJpcGUiLCJpc3MiOiJodHRwczovL2F1dGguZC1pZC5jb20vIiwic3ViIjoiZ29vZ2xlLW9hdXRoMnwxMTQyMTg1MzkyMDM1NTk0Nzc4NDgiLCJhdWQiOlsiaHR0cHM6Ly9kLWlkLnVzLmF1dGgwLmNvbS9hcGkvdjIvIiwiaHR0cHM6Ly9kLWlkLnVzLmF1dGgwLmNvbS91c2VyaW5mbyJdLCJpYXQiOjE3MzU4MzEzMzcsImV4cCI6MTczNTkxNzczNywic2NvcGUiOiJvcGVuaWQgcHJvZmlsZSBlbWFpbCByZWFkOmN1cnJlbnRfdXNlciB1cGRhdGU6Y3VycmVudF91c2VyX21ldGFkYXRhIG9mZmxpbmVfYWNjZXNzIiwiYXpwIjoiR3pyTkkxT3JlOUZNM0VlRFJmM20zejNUU3cwSmxSWXEifQ.oZfGSCi1mMBOgUffr_1wioCdvUe0cpUSqr9jFrrJdoCxHbDYDuSi8SZKAfhpHystJ-b9JU9Jv9pDWL27TfEaJRzt0XWbclr5cZm0XKU2OJTtnSHRHX0axv5aegQBGi6B63Z7sWGHdmrUpOplBnEbAPf9_nf9DBfI3PWVywc7YJPRWJf-ETH4fi6LqkA_gmxfbKE3tMcfNACtu0UugxKm0nwivs-YtGswcdkV5H3L-w6VhWDyFpKwgAKx1MNOULRMHgPoNRPzYYa7zuafmKcIMxVMZYl_2U9NDJOtjjZX1UDi7StU6MwTTODdCHa-vXYf9CqUDXQSPP4gbtsR6NW24Q'
    }
  };

  const options = {
    method: 'POST',
    headers: {
      accept: 'application/json',
      'content-type': 'application/json',
      authorization:
        'Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6Ik53ek53TmV1R3ptcFZTQjNVZ0J4ZyJ9.eyJodHRwczovL2QtaWQuY29tL2ZlYXR1cmVzIjoiIiwiaHR0cHM6Ly9kLWlkLmNvbS9zdHJpcGVfcHJvZHVjdF9pZCI6IiIsImh0dHBzOi8vZC1pZC5jb20vc3RyaXBlX2N1c3RvbWVyX2lkIjoiIiwiaHR0cHM6Ly9kLWlkLmNvbS9zdHJpcGVfcHJvZHVjdF9uYW1lIjoidHJpYWwiLCJodHRwczovL2QtaWQuY29tL3N0cmlwZV9zdWJzY3JpcHRpb25faWQiOiIiLCJodHRwczovL2QtaWQuY29tL3N0cmlwZV9iaWxsaW5nX2ludGVydmFsIjoibW9udGgiLCJodHRwczovL2QtaWQuY29tL3N0cmlwZV9wbGFuX2dyb3VwIjoiZGVpZC10cmlhbCIsImh0dHBzOi8vZC1pZC5jb20vc3RyaXBlX3ByaWNlX2lkIjoiIiwiaHR0cHM6Ly9kLWlkLmNvbS9zdHJpcGVfcHJpY2VfY3JlZGl0cyI6IiIsImh0dHBzOi8vZC1pZC5jb20vY2hhdF9zdHJpcGVfc3Vic2NyaXB0aW9uX2lkIjoiIiwiaHR0cHM6Ly9kLWlkLmNvbS9jaGF0X3N0cmlwZV9wcmljZV9jcmVkaXRzIjoiIiwiaHR0cHM6Ly9kLWlkLmNvbS9jaGF0X3N0cmlwZV9wcmljZV9pZCI6IiIsImh0dHBzOi8vZC1pZC5jb20vcHJvdmlkZXIiOiJnb29nbGUtb2F1dGgyIiwiaHR0cHM6Ly9kLWlkLmNvbS9pc19uZXciOmZhbHNlLCJodHRwczovL2QtaWQuY29tL2FwaV9rZXlfbW9kaWZpZWRfYXQiOiIyMDI1LTAxLTAyVDE1OjExOjQwLjIzMloiLCJodHRwczovL2QtaWQuY29tL29yZ19pZCI6IiIsImh0dHBzOi8vZC1pZC5jb20vYXBwc192aXNpdGVkIjpbIlN0dWRpbyJdLCJodHRwczovL2QtaWQuY29tL2N4X2xvZ2ljX2lkIjoiIiwiaHR0cHM6Ly9kLWlkLmNvbS9jcmVhdGlvbl90aW1lc3RhbXAiOiIyMDI1LTAxLTAyVDE1OjEwOjM4Ljg2NloiLCJodHRwczovL2QtaWQuY29tL2FwaV9nYXRld2F5X2tleV9pZCI6InNwc2x6N2ZzcjkiLCJodHRwczovL2QtaWQuY29tL3VzYWdlX2lkZW50aWZpZXJfa2V5IjoickZyTk5SbGtyV25MM3VSNFpyZnA1IiwiaHR0cHM6Ly9kLWlkLmNvbS9oYXNoX2tleSI6ImZMNVZJRUNGVHB0Z0c2YUpCM3ROaCIsImh0dHBzOi8vZC1pZC5jb20vcHJpbWFyeSI6dHJ1ZSwiaHR0cHM6Ly9kLWlkLmNvbS9lbWFpbCI6ImZhdGVoLmFsbGFtQGdtYWlsLmNvbSIsImh0dHBzOi8vZC1pZC5jb20vY291bnRyeV9jb2RlIjoiUEsiLCJodHRwczovL2QtaWQuY29tL3BheW1lbnRfcHJvdmlkZXIiOiJzdHJpcGUiLCJpc3MiOiJodHRwczovL2F1dGguZC1pZC5jb20vIiwic3ViIjoiZ29vZ2xlLW9hdXRoMnwxMTQyMTg1MzkyMDM1NTk0Nzc4NDgiLCJhdWQiOlsiaHR0cHM6Ly9kLWlkLnVzLmF1dGgwLmNvbS9hcGkvdjIvIiwiaHR0cHM6Ly9kLWlkLnVzLmF1dGgwLmNvbS91c2VyaW5mbyJdLCJpYXQiOjE3MzU4MzEzMzcsImV4cCI6MTczNTkxNzczNywic2NvcGUiOiJvcGVuaWQgcHJvZmlsZSBlbWFpbCByZWFkOmN1cnJlbnRfdXNlciB1cGRhdGU6Y3VycmVudF91c2VyX21ldGFkYXRhIG9mZmxpbmVfYWNjZXNzIiwiYXpwIjoiR3pyTkkxT3JlOUZNM0VlRFJmM20zejNUU3cwSmxSWXEifQ.oZfGSCi1mMBOgUffr_1wioCdvUe0cpUSqr9jFrrJdoCxHbDYDuSi8SZKAfhpHystJ-b9JU9Jv9pDWL27TfEaJRzt0XWbclr5cZm0XKU2OJTtnSHRHX0axv5aegQBGi6B63Z7sWGHdmrUpOplBnEbAPf9_nf9DBfI3PWVywc7YJPRWJf-ETH4fi6LqkA_gmxfbKE3tMcfNACtu0UugxKm0nwivs-YtGswcdkV5H3L-w6VhWDyFpKwgAKx1MNOULRMHgPoNRPzYYa7zuafmKcIMxVMZYl_2U9NDJOtjjZX1UDi7StU6MwTTODdCHa-vXYf9CqUDXQSPP4gbtsR6NW24Q',
    },
    body: JSON.stringify({
      source_url:
        'https://d-id-public-bucket.s3.us-west-2.amazonaws.com/alice.jpg',
      script: {
        type: 'text',
        subtitles: 'false',
        provider: { type: 'microsoft', voice_id: 'Sara' },
        input: 'Making videos is easy with D-ID',
      },
      config: { fluent: 'false', pad_audio: '0.0' },
    }),
  }

  //   {
  //     "id": "tlk_5spAiNx3NEgme8jwqeWrU",
  //     "created_at": "2025-01-02T15:27:49.809Z",
  //     "created_by": "google-oauth2|114218539203559477848",
  //     "status": "created",
  //     "object": "talk"
  // }

  const generateTalkingHead = async () => {
    // const response = await axios.post(
    //   "https://api.d-id.com/talking-head",
    //   {
    //     image_url: "https://drive.google.com/file/d/13Ganvsdamuq4gSGJA-bwjyzZv0pv4acO/view?usp=sharing",
    //     text: "Hello, welcome to our app!",
    //   },
    //   {
    //     headers: {
    //       "Content-Type": "application/json",
    //       Authorization: `ZmF0ZWguYWxsYW1AZ21haWwuY29t:Ibu9GdNeunjhcPSUOxHHt`,
    //     },
    //   }
    // );
    // console.log(response.data);

    fetch(url, options)
      .then((res) => res.json())
      .then((json) => {
        console.log(json)
        fetch(url, options)
          .then(res => res.json())
          .then(json => console.log(json))
          .catch(err => console.error(err));
      })
      .catch((err) => console.error(err))
  }

  const speak = () => {
    if (text.trim() === '') return

    const synth = window.speechSynthesis
    const utterance = new SpeechSynthesisUtterance(text)

    // Start animation
    setIsSpeaking(true)

    // Stop animation when speech ends
    utterance.onend = () => setIsSpeaking(false)

    // Speak the text
    synth.speak(utterance)

    generateTalkingHead()
  }

  return (
    <div style={containerStyles}>
      {/* Talking Head Animation */}
      <Lottie
        loop
        animationData={talkingHeadAnimation}
        play={isSpeaking} // Play only when speaking
        style={styles.avatar}
        onClick={() => -speak()}
      />

      {/* Text Input */}
      {/* <textarea
        placeholder="Enter text to speak"
        value={text}
        // onChange={(e) => setText(e.target.value)}
        style={styles.textArea}
      /> */}

      {/* Speak Button */}
      {/* <button onClick={speak} style={styles.button}>
        Speak
      </button> */}
    </div>
  )
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
  },
  avatar: {
    width: '300px',
    height: '300px',
    marginBottom: '20px',
  },
  textArea: {
    width: '100%',
    maxWidth: '400px',
    height: '100px',
    padding: '10px',
    marginBottom: '20px',
    fontSize: '16px',
  },
  button: {
    padding: '10px 20px',
    fontSize: '16px',
    cursor: 'pointer',
  },
}

export default TalkingHead
